import styled from 'styled-components';
import { themeGet } from 'styled-system';

export const StyledJobCard = styled.div.attrs({
  role: 'button',
})`
  flex: 1;
  width: 280px;
  min-width: 100%;
  min-height: 100%;
  background-color: ${themeGet('colors.white')};
  border-radius: 12px;
  border: 1px solid rgba(235, 240, 245, 0.6);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  cursor: pointer;
  margin-bottom: 30px;
  position: relative;
  overflow: visible;
  padding-bottom: 20px;

  .cover-wrapper {
    height: 140px;
    width: 100%;
    overflow: hidden;
    position: relative;
    border-radius: 12px 12px 0 0;
    background-color: ${themeGet('colors.iceBlue')};
    z-index: 1;
  }

  .cover {
    max-width: 100%;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;
  }

  .logo {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    position: absolute;
    left: 10px;
    top: 70px;
    background-color: white;
    border: 3px solid white;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    object-fit: contain;
    z-index: 10;
  }

  &:hover {
    box-shadow: 0 12px 24px rgba(79, 85, 104, 0.1);
    transform: translateY(-4px);
    border-color: rgba(235, 240, 245, 1);

    .cover {
      transform: scale(1.05);
    }
  }

  &:nth-child(odd) {
    margin-right: 0px;
  }

  @media screen and (min-width: 1235px) {
    min-width: calc(50% - 15px);
  }
  @media screen and (min-width: 1660px) {
    min-width: calc(33% - 20px);
    margin-right: 30px;
    &:nth-child(3n) {
      margin-right: 0px;
    }
  }

  @media screen and (min-width: ${themeGet('breakpoints.md')}px) {
    &:nth-child(odd) {
      margin-right: 30px;
    }
  }
  &:only-child {
    margin-right: 0;
  }

  img {
    text-indent: 100%;
    white-space: nowrap;
    overflow: hidden;
  }
`;
